import { createStore } from "vuex";

import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import state from "./state";

import courses from "./courses";
import articles from "./articles";
import podcasts from "./podcasts";
import lives from "./lives";
import user from "./user";
import home from "./home";
import lessons from "./lessons";
import forum from "./forum";
import conferences from "./conferences";
import library from "./library";
import notifications from "./notifications";
import search from "./search";
import plans from "./plans";

export default createStore({
  state,
  getters,
  mutations,
  actions,
  modules: {
    courses,
    user,
    home,
    lessons,
    forum,
    conferences,
    library,
    notifications,
    search,
    plans,
    articles,
    podcasts,
    lives,
  },
});
